export default __webpack_public_path__ + "static/media/today.79211964.png";